import React from 'react'
import {useSelector} from 'react-redux'
import BrandAtom from '../../@atoms/to_content/brand/brand.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import {RootState} from '../../store_redux'

interface BrandGetComponentProps {
  ap_position: 'app_bar' | 'app_content_area'
}

const BrandGetComponent: React.FC<BrandGetComponentProps> = function ({
  ap_position,
}) {
  const logo = useSelector((state: RootState) => state.brand.logo)

  return !logo ? (
    <SkeletonAtom ap_type={`brand_${ap_position}_skeleton`} />
  ) : (
    <BrandAtom ap_brand={logo} ap_position={ap_position} />
  )
}

export default BrandGetComponent
